import * as React from 'react';

import { useSelectionContext } from 'common/contexts/SelectionContext';
import { Customer } from 'types/Customer';
import { AddCustomerButton } from 'components/ContainerActions';
import { AssignmentModal } from 'pages/TrackAndTrace/components/customer-tag/assignment-modal';

interface Props {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const AddCustomerIdButton: React.FC<Props> = (props) => {
  const { selection } = useSelectionContext();

  const [modalOpen, setModalOpen] = React.useState(false);

  /**
   * We want to prepopulate the initial customer tag in the modal in these scenarios
   * 1. All selected containers are assigned the same 1 and only 1 customer tag
   * In all other cases, we do not prepopulate
   */
  const initialCustomer = React.useMemo(() => {
    if (selection.model !== 'page') {
      return undefined;
    }

    // Check for any unassigned containers
    const containersWithCustomers = selection.containers.filter((c) => c.customer !== null);
    if (containersWithCustomers.length !== selection.containers.length) {
      return undefined;
    }

    // Verify there is only 1 customer in this selection
    const customers = new Map<string, Customer>();
    containersWithCustomers.forEach((c) => {
      if (c.customer) {
        customers.set(c.customer.code, c.customer);
      }
    });
    if (customers.size === 1) {
      return customers.values().next().value as Customer;
    }

    return undefined;
  }, [selection]);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    setModalOpen(true);
    props.onClick?.(e);
  };

  return (
    <>
      <AddCustomerButton onClick={handleClick} />
      {modalOpen && (
        <AssignmentModal
          selection={selection}
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          initialCustomer={initialCustomer}
          method="assignment-modal"
        />
      )}
    </>
  );
};
